import { HDSButton } from '@here/hds-react-components'
import React from 'react'

export enum OrientationButtonMode {
  Default = '3D',
  TwoDimension = '2D',
  ThreeDimension = '3D',
  Compass = 'compass',
}

export interface OrientationButtonProps {
  mode: OrientationButtonMode
  onClick: (mode: OrientationButtonMode) => void
  className?: string
}

export default function OrientationButton({
  mode,
  onClick,
  className,
}: OrientationButtonProps): JSX.Element {
  const handleButtonClick = (): void => {
    onClick(mode)
  }
  return (
    <div className={className}>
      <HDSButton
        icon={mode}
        iconCategory="map-view"
        variant="floating"
        size="medium"
        onClick={handleButtonClick}
      />
    </div>
  )
}
